"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgLoadFactor = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M14.12 2.224 11.2 7.48 8.598 5.398 6.626 10h2.176l.6-1.398L11.148 10h.94l1.79-3.224L15.247 10h2.172l-3.298-7.776ZM19.965 16h-2.172l2.286 5.39 1.841-.78L19.965 16ZM6.23 16H4.056L2.08 20.606l1.838.788L6.231 16ZM3 12h2v2H3v-2ZM7 12h2v2H7v-2ZM11 12h2v2h-2v-2ZM15 12h2v2h-2v-2ZM19 12h2v2h-2v-2Z" })), 'SvgLoadFactor');
exports.default = SvgLoadFactor;
